import { render, staticRenderFns } from "./antiban.vue?vue&type=template&id=e59dd036"
import script from "./antiban.vue?vue&type=script&lang=js"
export * from "./antiban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports